import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showMoreTooltip: {
		id: 'issue-field-multi-select-readview-full.multi-select.compact.show-more-tooltip',
		defaultMessage: 'See more selected options',
		description: 'Label for trigger button to open a dialog with a list of selected options',
	},
});
